import { useQuery } from "@tanstack/react-query";
import { useApp } from "./app-context.tsx";
import { useAuthUser } from "./auth.ts";

/** The signed-in user's profile (display name, plan); null when signed out or there is no API. */
export function useMe() {
  const { api, auth } = useApp();
  const user = useAuthUser(auth);
  return useQuery({
    queryKey: ["me", user?.sub],
    queryFn: () => api!.me(),
    enabled: !!(api && user),
    staleTime: 5 * 60_000,
  });
}
